<template>
    <div>
        <div class="bg-cover" style="background-image: url(/images/banner-bg.jpg)">
            <div class="container py-12">
                <h1 class="text-4xl uppercase font-light">QUIZZES</h1>
            </div>
        </div>

        <div class="container mt-4">

            <Breadcrumbs :breadcrumbs="[
                {label: 'Home', href: '/'},
                {label: 'QUIZZES', href: `/quizzes`}

            ]" class="mb-4"/>

            <div class="row">

                <div class="md:col-2/3 lg:col-3/4 my-8">
                    <template v-if="posts.length">
                        <PostsList :posts="posts" :view="view"/>
                    </template>
                    <p v-else class="text-sm bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3">
                        There are no quizzes available yet.
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import Layout from "@app/Shared/Components/Layout";
import Breadcrumbs from "@app/Shared/Components/Breadcrumbs";
import HasMetaData from "@app/Shared/Mixins/HasMetaData";
import PostsList from "@app/Shared/Components/PostsList";


export default {

    mixins: [HasMetaData],

    props: {
        posts: Array,
    },

    data() {
        return {
            preserveScroll: true,
            query: {
                view: 'detail_view',
            },
        }
    },

    layout: Layout,

    components: {
        Breadcrumbs,
        PostsList,
    },
    computed: {
        view: {
            get() {
                return this.query.view;
            },
            set(value) {
                this.query.view = value;
            }
        },
    },
};

</script>
